// Add all files that need to be pre-loaded here, e.g. font icons
import { MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';

export const sharedCachedFonts = {
  // Font Icons
  ...MaterialCommunityIcons.font,
  ...MaterialIcons.font,
};
